export default {
    install(vue) {
        console.log("plugins install")

        //java可以调用js方法。
        global.callJsFromJava = (type, param) => {
            console.log("@@@@@---- type = " + type)
            console.log("@@@@@---- param = " + param.toString())

            if (type === "inputEnd") {
                let event = new CustomEvent(type, {
                    detail: param
                });
                window.dispatchEvent(event);
            } else if (type === "idCardCheckEvent") {
                let event = new CustomEvent(type, {
                    detail: param
                });
                window.dispatchEvent(event);
            }


            return "js data"
        }

        //js可以调用java类，注册到全局vue中，可以在页面中直接调用类中方法。
        if (window.FaceReco) {
            // vue.prototype.FaceReco = window.FaceReco
            // vue.prototype.FingerPrint = window.FingerPrint
            vue.prototype.JavaBaseInfo = window.JavaBaseInfo
            vue.prototype.JavaBaseInfo.isDebugEnv = () => {return false}
            vue.prototype.IdCardCheck = window.IdCardCheck
            vue.prototype.PrintInfo = window.PrintInfo
            vue.prototype.JavaCardApi = window.JavaCardApi
        } else {
            console.log("js bridge is null")
            let empty = () => {
                console.log("empty, not impl without java")
            }
            // 纯 H5 部署（无安卓壳）：设备信息与本地设置持久化到 localStorage
            const LS_KEY = "pad.terminal.info"
            const readInfo = () => {
                try {
                    return JSON.parse(localStorage.getItem(LS_KEY)) || {}
                } catch (e) {
                    return {}
                }
            }
            vue.prototype.JavaBaseInfo = {
                isDebugEnv: () => {
                    return true
                },
                setBaseInfo: (key, value) => {
                    const info = readInfo()
                    info[key] = value == null ? "" : String(value)
                    localStorage.setItem(LS_KEY, JSON.stringify(info))
                },
                getBaseInfo: (key) => {
                    const v = readInfo()[key]
                    return v == null ? "" : v
                },
                getBase64Image: empty,
                openCameraSettingPage: empty,
                openUsbPrinterSettingPage: empty,
                getFaceSdkInitStatus: empty,
                getFaceSdkErrorMsg: empty,
            }
            vue.prototype.IdCardCheck = {
                startCheckIdCard: empty,
            }
            vue.prototype.PrintInfo = {
                printVisitorInfo: empty,
            }
            vue.prototype.JavaCardApi = {
                readCard: empty,
            }
        }

    }//end install
}
